const Icons = [
    'fa-solid:handshake',
    'noto:people-holding-hands-light-skin-tone',
    'twemoji:sparkles',
    'twemoji:handshake',
    'twemoji:waving-hand',
    'twemoji:raised-hand',
    'twemoji:sparkles',
    'twemoji:handshake',
    'twemoji:sun-with-face',
    'twemoji:waving-hand',
    'twemoji:raised-hand',
    'twemoji:sun-with-face',
    'twemoji:sparkles',
    'twemoji:wave',
    'twemoji:handshake',
    'twemoji:grinning-face-with-big-eyes',
    'twemoji:waving-hand',
    'twemoji:raised-hand',
    'twemoji:sparkles',
    'twemoji:sun-with-face',
    'twemoji:confetti-ball',
    'twemoji:fireworks',
    'twemoji:rainbow',
    'twemoji:balloon',
    'twemoji:sparkles',
    'twemoji:partying-face',
    'twemoji:thumbs-up',
  ];

  export default Icons;